import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getListsLoaded } from 'store/lists/selectors';
import { fetchLists } from 'store/lists/actions';
import useAction from './useAction';

const useLoadLists = () => {
  const areListsLoaded = useSelector(getListsLoaded);
  const fetchListsFunc = useAction(fetchLists);

  useEffect(() => {
    if (!areListsLoaded) fetchListsFunc();
  }, []);
};

export default useLoadLists;
